module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/pescetarian@2x__c6832833b5dbd683d0c281da02ef7d16.png";